import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Link from 'react-router/lib/Link';
import { Fieldset, Row, Field } from 'react-gridforms';
import { Form } from 'react-redux-form/immutable';
import Input from 'bisu-react-input';

import FieldGroupRow from 'components/FieldGroupRow';
import Loading from 'components/Loading';
import photo from 'assets/img/default-profile.png';
import ConfirmDialog from 'components/ConfirmDialog';
import { resetPassword } from './actions';

class StudentsProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirm: false,
      pending: false,
    };
  }

  _showConfirm = () => {
    this.setState({
      showConfirm: true,
    });
  };

  _hideConfirm = () => {
    this.setState({
      showConfirm: false,
    });
  };

  _onReset = () => {
    const { dispatch, __studentState } = this.props;
    this.setState({
      pending: true,
    });
    dispatch(resetPassword(__studentState.get('id'))).then((res) => {
      if (!res.error) {
        this.setState({
          pending: false,
        });
        this._hideConfirm();
      }
    });
  };

  _renderConfirm() {
    const { showConfirm, pending } = this.state;
    const { __studentState } = this.props;
    if (!showConfirm) {
      return null;
    }
    return (
      <ConfirmDialog
        msg={`Are you sure you want to reset password for ${__studentState.get(
          'full_name2'
        )}?`}
        closeDialog={this._hideConfirm}
        confirmAction={this._onReset}
        btnClass='btn-danger'
        pending={pending}
      />
    );
  }

  render() {
    const { params, __studentState, __pending } = this.props;
    let id = Number(params.studentID);
    if (__pending || id !== __studentState.get('id')) {
      return <Loading />;
    }
    return (
      <div>
        <div className='text-right'>
          <button onClick={this._showConfirm} className='btn btn-warning'>
            Reset Password
          </button>
          {` `}
          <Link to={`/students/${id}/edit`} className='btn btn-info'>
            Edit Student
          </Link>
        </div>
        <div className='m-a-3 text-center'>
          <img
            className='profile-pic'
            src={
              !__studentState.get('photo') ? photo : __studentState.get('photo')
            }
            alt=''
          />
          <h4>{__studentState.get('full_name1')}</h4>
          <h6>
            ID #: <kbd>{id}</kbd>
          </h6>
        </div>
        <Form model='studentState' className='grid-form m-b-1 row'>
          <div className='col-sm-9'>
            <Fieldset legend='Basic Information' disabled={true}>
              <FieldGroupRow model='.last_name' label='Last Name' />
              <FieldGroupRow model='.first_name' label='First Name' />
              <Row>
                <Field span='7'>
                  <Input model='.middle_name' label='Middle Name' />
                </Field>
                <Field span='1'>
                  <Input model='.suffix_name' label='Ext.' />
                </Field>
              </Row>
              <Row>
                <Field span='3'>
                  <Input model='.civil_status' label='Civil Status' />
                </Field>
                <Field span='3'>
                  <Input model='.sex' label='Sex' />
                </Field>
                <Field span='3'>
                  <Input model='.dob' label='Date of Birth' />
                </Field>
              </Row>
              <Row>
                <Field span='7'>
                  <Input model='.address' label='Address' />
                </Field>
                <Field span='1'>
                  <Input model='.zip' label='Zip Code' />
                </Field>
              </Row>
            </Fieldset>
          </div>
          <div className='col-sm-3'>
            <Fieldset legend='Account Information' disabled>
              <FieldGroupRow model='.username' label='Username' />
              <FieldGroupRow model='.email' label='Email Address' />
            </Fieldset>
          </div>
        </Form>
        {this._renderConfirm()}
      </div>
    );
  }
}

StudentsProfile.propTypes = {
  params: PropTypes.object,
  __studentState: PropTypes.object,
  __pending: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    __studentState: state.studentState,
    __pending: state.student.get('pending'),
  };
}

export default connect(mapStateToProps)(StudentsProfile);



// WEBPACK FOOTER //
// ./src/containers/Students/profile.js